import { ReactNode } from 'react';
import { IconType } from 'react-icons';
import { BsLinkedin } from 'react-icons/bs';
import { FaSquareXTwitter } from 'react-icons/fa6';
import {
    TbBan,
    TbBolt,
    TbBuildingEstate,
    TbCalendarBolt,
    TbCalendarStar,
    TbCash,
    TbCircleCheck,
    TbClockHour4,
    TbClockX,
    TbCoins,
    TbFileDescription,
    TbId,
    TbMail,
    TbMailBolt,
    TbMapPin,
    TbMapPin2,
    TbPhone,
    TbTags,
    TbUserScan,
    TbUserStar,
    TbWorld,
} from 'react-icons/tb';

import { NavigationRouteIcon } from '@/shared/components/icons';
import { WORKSPACE_LIST_TYPE_ICON_REGISTRY } from '@/shared/components/workspace-resources';
import { ListType, WorkspaceInvitationStatusType } from '@/types';

export const createRouteListIconMaps = () => {
    const PeopleListIcon = WORKSPACE_LIST_TYPE_ICON_REGISTRY.people;
    const CompaniesListIcon = WORKSPACE_LIST_TYPE_ICON_REGISTRY.companies;
    const CustomListIcon = WORKSPACE_LIST_TYPE_ICON_REGISTRY.custom;
    const routeToIconMap = {
        '/': <NavigationRouteIcon route='home' style={{ verticalAlign: '-0.1rem', marginRight: '0.25rem' }} />,
        '/search': <NavigationRouteIcon route='search' style={{ verticalAlign: '-0.1rem', marginRight: '0.25rem' }} />,
        '/dashboards': <NavigationRouteIcon route='dashboards' style={{ marginRight: '0.25rem' }} />,
        '/relations/dashboards': <NavigationRouteIcon route='dashboards' style={{ marginRight: '0.25rem' }} />,
        '/folders': <NavigationRouteIcon route='folders' style={{ marginRight: '0.25rem' }} />,
        '/investments': <NavigationRouteIcon route='investments' style={{ marginRight: '0.25rem' }} />,
        '/lifecycles': <NavigationRouteIcon route='lifecycles' style={{ marginRight: '0.25rem' }} />,
        '/lists': <NavigationRouteIcon route='lists' style={{ marginRight: '0.25rem' }} />,
        '/relations/lists': <NavigationRouteIcon route='lists' style={{ marginRight: '0.25rem' }} />,
        '/memos': <NavigationRouteIcon route='memos' style={{ marginRight: '0.25rem' }} />,
        '/pipelines': <NavigationRouteIcon route='pipelines' style={{ marginRight: '0.25rem' }} />,
        '/relations/tasks': <NavigationRouteIcon route='tasks' style={{ marginRight: '0.25rem' }} />,
        '/relations': (
            <NavigationRouteIcon route='relations' style={{ verticalAlign: '-0.1rem', marginRight: '0.25rem' }} />
        ),
        '/profile': (
            <NavigationRouteIcon route='profile' style={{ verticalAlign: '-0.1rem', marginRight: '0.25rem' }} />
        ),
        '/settings': (
            <NavigationRouteIcon route='settings' style={{ verticalAlign: '-0.1rem', marginRight: '0.25rem' }} />
        ),
    } as Record<string, ReactNode>;

    const listTypeToIconMap = {
        [ListType.PEOPLE]: <PeopleListIcon style={{ verticalAlign: '-0.125rem', marginRight: '0.375rem' }} />,
        [ListType.COMPANIES]: <CompaniesListIcon style={{ verticalAlign: '-0.125rem', marginRight: '0.375rem' }} />,
        [ListType.CUSTOM]: <CustomListIcon style={{ verticalAlign: '-0.125rem', marginRight: '0.375rem' }} />,
    } as Record<ListType, ReactNode>;

    const peopleColumnsToIconMap = {
        person: <TbUserScan size='1rem' style={{ verticalAlign: '-0.15rem', marginRight: '0.375rem' }} />,
        company: <TbBuildingEstate size='1rem' style={{ verticalAlign: '-0.15rem', marginRight: '0.375rem' }} />,
        title: <TbId size='1rem' style={{ verticalAlign: '-0.15rem', marginRight: '0.375rem' }} />,
        connectionStrength: <TbBolt size='1rem' style={{ verticalAlign: '-0.15rem', marginRight: '0.375rem' }} />,
        emailAddress: <TbMail size='1rem' style={{ verticalAlign: '-0.15rem', marginRight: '0.375rem' }} />,
        phoneNumber: <TbPhone size='1rem' style={{ verticalAlign: '-0.15rem', marginRight: '0.375rem' }} />,
        location: <TbMapPin size='1rem' style={{ verticalAlign: '-0.15rem', marginRight: '0.375rem' }} />,
        linkedin: <BsLinkedin size='1rem' style={{ verticalAlign: '-0.15rem', marginRight: '0.375rem' }} />,
        twitter: <FaSquareXTwitter size='1rem' style={{ verticalAlign: '-0.15rem', marginRight: '0.375rem' }} />,
        lastEmailInteraction: <TbMailBolt size='1rem' style={{ verticalAlign: '-0.15rem', marginRight: '0.375rem' }} />,
        lastCalendarInteraction: (
            <TbCalendarBolt size='1rem' style={{ verticalAlign: '-0.15rem', marginRight: '0.375rem' }} />
        ),
    } as Record<string, ReactNode>;

    const companyColumnsIconsToMap = {
        company: <TbBuildingEstate size='1rem' style={{ verticalAlign: '-0.15rem', marginRight: '0.375rem' }} />,
        description: <TbFileDescription size='1rem' style={{ verticalAlign: '-0.15rem', marginRight: '0.375rem' }} />,
        categories: <TbTags size='1rem' style={{ verticalAlign: '-0.15rem', marginRight: '0.375rem' }} />,
        website: <TbWorld size='1rem' style={{ verticalAlign: '-0.15rem', marginRight: '0.375rem' }} />,
        annualRevenue: <TbCash size='1rem' style={{ verticalAlign: '-0.15rem', marginRight: '0.375rem' }} />,
        capitalRaised: <TbCoins size='1rem' style={{ verticalAlign: '-0.15rem', marginRight: '0.375rem' }} />,
        headquarters: <TbMapPin2 size='1rem' style={{ verticalAlign: '-0.15rem', marginRight: '0.375rem' }} />,
        linkedin: <BsLinkedin size='1rem' style={{ verticalAlign: '-0.15rem', marginRight: '0.375rem' }} />,
        twitter: <FaSquareXTwitter size='1rem' style={{ verticalAlign: '-0.15rem', marginRight: '0.375rem' }} />,
        foundingYear: <TbCalendarStar size='1rem' style={{ verticalAlign: '-0.15rem', marginRight: '0.375rem' }} />,
        keyContact: <TbUserStar size='1rem' style={{ verticalAlign: '-0.15rem', marginRight: '0.375rem' }} />,
        connectionStrength: <TbBolt size='1rem' style={{ verticalAlign: '-0.15rem', marginRight: '0.375rem' }} />,
        lastEmailInteraction: <TbMailBolt size='1rem' style={{ verticalAlign: '-0.15rem', marginRight: '0.375rem' }} />,
        lastCalendarInteraction: (
            <TbCalendarBolt size='1rem' style={{ verticalAlign: '-0.15rem', marginRight: '0.375rem' }} />
        ),
    } as Record<string, ReactNode>;

    const iconMapByListTypeMap = {
        [ListType.PEOPLE]: peopleColumnsToIconMap,
        [ListType.COMPANIES]: companyColumnsIconsToMap,
    } as Record<ListType, typeof peopleColumnsToIconMap | typeof companyColumnsIconsToMap>;

    const invitationStatusIconMap = {
        [WorkspaceInvitationStatusType.PENDING]: TbClockHour4,
        [WorkspaceInvitationStatusType.ACCEPTED]: TbCircleCheck,
        [WorkspaceInvitationStatusType.REVOKED]: TbBan,
        [WorkspaceInvitationStatusType.EXPIRED]: TbClockX,
    } as Record<WorkspaceInvitationStatusType, IconType>;

    return {
        routeToIconMap,
        listTypeToIconMap,
        peopleColumnsToIconMap,
        companyColumnsIconsToMap,
        iconMapByListTypeMap,
        invitationStatusIconMap,
    };
};
